const enableCommonCallbackEvent = () => {
  console.log("[enableCommonCallbackEvent]");
  if (typeof window === "undefined") {
    console.warn("common callback event can't be listened on node environment.");
    return;
  }
  window.KakaoPay.webEventCallback = ({ type, parameters }) => {
    console.log(`[webEventCallback]${type} ${JSON.stringify(parameters)}`);
    const storageEvent = new CustomEvent(type, {
      detail: parameters
    });
    document.dispatchEvent(storageEvent);
  };
};
export {
  enableCommonCallbackEvent
};
